import VueRouter from 'vue-router';
import store from "../store";
import routes, { isGuestRoute, saveRedirectUrl } from "./routes";

const router = new VueRouter({
    routes,
    mode: 'history',
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters["auth/isAuthenticated"];
    const isCustomer = store.getters["auth/isCustomer"];
    const isLabor = store.getters["auth/isLabor"];

    let name;

    if (isAuthenticated && isGuestRoute(to.name)) {

        if(isCustomer) {
            name = 'user-dashboard';
        } else if (isLabor) {
            name = 'labor-dashboard';
        } else {
            name = 'dashboard';
        }
        return next({ name });
    }

    if (! isAuthenticated && ! isGuestRoute(to.name)) {
        saveRedirectUrl();
        return next({ name: 'login' });
    }

    if (!isCustomer && to.name === 'deliveries-tab' && isLabor) {
        return next({ name: 'labor-dashboard' });
    }

    if (isCustomer && to.name === 'deliveries-tab') {
        return next({ name: 'user-dashboard' });
    }

    next();
});

  /**
   * GTM dataLayer – Fire Pageview after route change
   */
  router.afterEach((to, from) => {
      // Ensure dataLayer exists
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
          event: 'pageview',               // GTM custom event name
          page_path: to.fullPath,          // /dashboard, etc.
          page_name: to.name || '',        // route name
          page_title: document.title,      // you can also customize per-route
          previous_page: from.fullPath || null
      });
  });

export default router;
